import React from "react"

const LockingSystemItemWrapper = ({
	children,
	isRowFirstItem = false,
	isCheckBoxItem = false,
	isKey = false,
	isKeyInput = false,
	isKeyFirstItem = false,
	isKeyLastItem = false,
	...props
}: Props) => {
	return (
		<div
			style={{
				background: "white",
				height: isKey || isKeyFirstItem ? "auto" : 60,
				padding: 5,

				// firstItem
				borderLeft: isRowFirstItem ? "3px solid #4691CE" : "none",
				borderTopLeftRadius: isRowFirstItem || isKeyFirstItem ? 8 : 0,
				borderBottomLeftRadius: isRowFirstItem || isKeyLastItem ? 8 : 0,

				// checkbox
				boxShadow: isCheckBoxItem
					? " 1px 1px 5px 0px rgba(0,0,0,0.15)"
					: "0 4px 2px -2px rgba(0,0,0,0.10)",
				borderRadius: isCheckBoxItem ? 5 : 0,
				marginLeft:
					isCheckBoxItem || isKeyFirstItem || isKeyInput || isKeyLastItem ? 2.5 : 0,
				marginRight:
					isCheckBoxItem || isKeyFirstItem || isKeyInput || isKeyLastItem ? 2.5 : 0,

				// key
				marginTop: isKeyInput ? -10 : 0,
				borderTop: isKeyFirstItem ? "3px solid #4691CE" : "none",
				borderTopRightRadius: isKeyFirstItem || isCheckBoxItem ? 5 : 0,
				borderBottomRightRadius: isCheckBoxItem ? 5 : 0,
			}}
			{...props}
		>
			{children}
		</div>
	)
}

interface Props
	extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
	children: React.ReactNode
	isRowFirstItem?: boolean
	isCheckBoxItem?: boolean
	isKey?: boolean
	isKeyInput?: boolean
	isKeyFirstItem?: boolean
	isKeyLastItem?: boolean
}

export default LockingSystemItemWrapper
